const PricePrerender = (data: any) => {
	if (!data) return 0;
	if (data.price === 0 || data.price === null) {
		if (data.sizes) {
			if (data.sizes.length > 0) {
				const defaultSize = data.sizes.find((item: any) => item.is_default === true);
				if (!defaultSize) {
					return data.sizes.length > 1 ? (data.sizes[1].price ?? data.sizes[0].price) : data.sizes[0].price;
				} else {
					return defaultSize.price;
				}
			}
		}
	}
	return data.price;
};

export default PricePrerender;
